import React from 'react'
import { css } from 'emotion'
import createMediaQueries from '../../../util/createMediaQueries'
import ReactHtmlParser from 'react-html-parser'

const Text: React.StatelessComponent<any> = ({ is = 'p', ...props }) => {
  const styles = props.css ? createMediaQueries(props.css) : {}
  props.className = css(styles)
  if (props.hasOwnProperty('htmlText')) {
    props.children = ReactHtmlParser(props.htmlText)
    delete props.htmlText
  }
  return React.createElement(is, props, props.children)
}

export default Text
